/** İkon adı → @lucide/vue bileşeni eşlemesi (dinamik/`<LucideIcon>` ikonları için). */
import type {Component} from 'vue'
import {
  AlignCenter,
  AlignJustify,
  AlignLeft,
  AlignRight,
  AppWindow,
  ArrowDown,
  ArrowDownToLine,
  ArrowLeft,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightLeft,
  ArrowRightToLine,
  ArrowUp,
  ArrowUpToLine,
  Astroid,
  AtSign,
  AudioLines,
  Ban,
  Banknote,
  Bell,
  Blocks,
  Bold,
  Bookmark,
  BookUser,
  Briefcase,
  Building,
  Building2,
  Calendar,
  CalendarDays,
  Check,
  CheckCheck,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsDown,
  ChevronsRight,
  ChevronsUp,
  ChevronsUpDown,
  ChevronUp,
  CircleArrowDown,
  CircleCheck,
  CircleHelp,
  CircleMinus,
  CircleX,
  Clock,
  Code,
  CodeXml,
  Command,
  Contact,
  Copy,
  CornerDownLeft,
  DollarSign,
  Download,
  Ellipsis,
  EllipsisVertical,
  Equal,
  Eraser,
  Euro,
  ExternalLink,
  Eye,
  EyeOff,
  Factory,
  File,
  FileCheck,
  FileClock,
  FileDown,
  FileInput,
  FileSearchCorner,
  FileSpreadsheet,
  FileSymlink,
  FileText,
  FileUp,
  Filter,
  FolderOpen,
  FoldVertical,
  Glasses,
  Globe,
  Grid2x2,
  Hand,
  Hash,
  Heading,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heart,
  Highlighter,
  History,
  Hourglass,
  Image,
  IndianRupee,
  Info,
  Italic,
  JapaneseYen,
  Keyboard,
  Layers,
  Link,
  List,
  Lightbulb,
  LoaderCircle,
  LocateFixed,
  Lock,
  LockOpen,
  LogOut,
  Mail,
  Mailbox,
  MailOpen,
  MapPin,
  MapPinCheck,
  Maximize,
  Maximize2,
  Menu,
  MessageCircle,
  MessageSquare,
  MessagesSquare,
  Mic,
  MicOff,
  Minimize,
  Minus,
  MonitorSmartphone,
  Moon,
  MoonStar,
  MousePointer2,
  Option,
  Paperclip,
  PanelLeft,
  PanelRight,
  Pen,
  Pencil,
  Percent,
  Phone,
  Pilcrow,
  Pin,
  Play,
  Plug,
  Plus,
  PoundSterling,
  Receipt,
  RefreshCw,
  Repeat,
  RotateCcw,
  RotateCw,
  Scale,
  Search,
  Send,
  Settings,
  Share2,
  ShieldCheck,
  ShieldEllipsis,
  Smartphone,
  Sparkles,
  Square,
  SquareCheck,
  Strikethrough,
  Sun,
  Table,
  Tags,
  TextQuote,
  TextSearch,
  TriangleAlert,
  Trash2,
  TurkishLira,
  Type,
  Underline,
  Undo2,
  UnfoldVertical,
  Unlink,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  Users,
  UserX,
  Workflow,
  X,
  Zap,
  Bitcoin,
  Box,
  BrainCircuit,
  Cloud,
  Cpu,
  CreditCard,
  GalleryVerticalEnd,
  Gamepad2,
  Megaphone,
  Network,
  ShoppingCart,
  Star,
  Store,
  TextCursorInput,
  Waypoints,
  Wifi,
  Camera,
  Rocket,
  ListOrdered,
  ListTree,
  ListVideo,
  Timer,
  Smile,
  StickyNote,
  Shapes,
} from '@lucide/vue'

export const lucideIconMap: Record<string, Component> = {
  // Lucide ikonları — anahtar = bileşen adı (kısa yazım)
  ChevronDown, ChevronUp, ChevronLeft, ChevronRight, ChevronsDown, ChevronsUp, ChevronsRight, ArrowLeft,
  ArrowRight, ArrowUp, ArrowDown, ArrowLeftToLine, ArrowRightToLine, ArrowUpToLine, ArrowDownToLine, Download,
  CircleArrowDown, ChevronsUpDown, MousePointer2, CornerDownLeft, ArrowRightLeft, ExternalLink, Upload, RefreshCw,
  RotateCw, RotateCcw, Repeat, Undo2, UnfoldVertical, FoldVertical, Minimize, Maximize,
  Maximize2, Menu, AlignLeft, AlignJustify, X, CircleX, Check, CheckCheck,
  CircleCheck, SquareCheck, Square, Info, CircleHelp, TriangleAlert, Minus, CircleMinus,
  Plus, Settings, Copy, Trash2, Eraser, Ellipsis, EllipsisVertical, Eye,
  EyeOff, Lock, LockOpen, Link, Unlink, Filter, Bell, Zap,
  Bookmark, Pin, Hand, Heart, Astroid, Sparkles, LoaderCircle, Hourglass, Play,
  Plug, Share2, Send, ShieldEllipsis, ShieldCheck, Command, Keyboard, Option,
  Grid2x2, GalleryVerticalEnd, PanelLeft, PanelRight, AppWindow, Search, Layers, History, Scale,
  Glasses, Tags, AudioLines, Mic, MicOff, Moon, MoonStar, Sun,
  LogOut, Bold, Italic, Underline, Strikethrough, Highlighter, Heading, Heading1, Heading2, Heading3, Heading4, AlignCenter,
  AlignRight, List, TextQuote, TextSearch, Code, CodeXml, Table, Type, Pilcrow,
  Pen, Pencil, File, FileText, FileDown, FileUp, FileInput, FileSearchCorner, FileSpreadsheet, FileSymlink, FileCheck, FileClock,
  Receipt, FolderOpen, Image, Paperclip, User, Users, UserPlus, UserCheck,
  UserCog, UserX, Clock, Contact, BookUser, Mail, MailOpen, Mailbox,
  AtSign, Phone, Smartphone, MonitorSmartphone, MapPin, MapPinCheck, LocateFixed, Globe,
  Building2, Building, Factory, Briefcase, Ban, Calendar, CalendarDays, Hash,
  Percent, MessageCircle, MessageSquare, Workflow, Equal, DollarSign, Euro, PoundSterling, JapaneseYen,
  IndianRupee, TurkishLira, Banknote, Cloud, Cpu, BrainCircuit, Network, Waypoints,
  Bitcoin, CreditCard, Box, Gamepad2, Megaphone, Store, ShoppingCart, Wifi,
  TextCursorInput, Star, ListOrdered, ListTree, ListVideo, MessagesSquare, Timer, Smile, StickyNote, Shapes,
  Lightbulb, Blocks,

  // Sosyal/marka — Lucide jenerik karşılık (jira/youtube gerçek SVG: icon.vue)
  'google': Globe,
  'linkedin': Briefcase,
  'facebook': Globe,
  'instagram': Camera,
  'twitter': AtSign,
  'whatsapp': MessageCircle,
  'telegram': Send,
  'product-hunt': Rocket,
  'angellist': Briefcase,
}
